<template>

  <div id="header" :class="{hidden: !$store.getters.isHeaderVisible(this.$route)}">

    <svgicon :src="$store.state.pageIcon" class="icon" :width="20" :height="20"/>

    <div class="subtitle" v-if="$store.state.loggedUser.isReceptionUser">
      <!-- Company -->
      <template v-if="$store.state.contextBranch">
        {{$store.state.contextBranch.name}}
        <svgicon class="separator" src="icon/chevron.svg" :height="10" :width="6"></svgicon>
      </template>
      <!-- Branch -->
      <template v-if="$store.state.contextCompany">
        {{$store.state.contextCompany.name}}
        <svgicon class="separator" src="icon/chevron.svg" :height="10" :width="6"></svgicon>
      </template>
      <!-- Breadcrumbs -->
      <template v-for="(breadcrumb, breadcrumbIndex) in breadcrumbs">
        <router-link :to="breadcrumb.href">{{ breadcrumb.name }}</router-link>
        <svgicon class="separator" src="icon/chevron.svg" :height="10" :width="6" v-if="breadcrumbIndex < breadcrumbs.length - 1 || showingPageTitle"></svgicon>
      </template>
      <!-- Page title -->
      <template v-if="showingPageTitle">
        <span class="pageTitle">{{ pageTitle }}</span>
      </template>
    </div>

    <div class="subtitle" v-if="!$store.state.loggedUser.isReceptionUser">
      <!-- Super admin -->
      <template v-if="isSuperAdmin">
        <router-link :to="'/branches'">Admin</router-link>
        <svgicon class="separator" src="icon/chevron.svg" :height="10" :width="6"></svgicon>
      </template>
      <!-- Company -->
      <template v-if="$store.state.contextBranch && $store.getters.loggedUserHasBranchAdmin">
        <router-link :to="'/companies?branch=' + $store.state.contextBranch.id">
          {{ $store.state.contextBranch.name }}
        </router-link>
        <svgicon class="separator" src="icon/chevron.svg" :height="10" :width="6"></svgicon>
      </template>
      <!-- Branch -->
      <template v-if="$store.state.contextBranch && $store.state.contextCompany">
        <router-link :to="'/items?branch=' + $store.state.contextBranch.id + '&company=' + $store.state.contextCompany.id">
          {{ $store.state.contextCompany.name }}
        </router-link>
        <svgicon class="separator" src="icon/chevron.svg" :height="10" :width="6"></svgicon>
      </template>
      <!-- Breadcrumbs -->
      <template v-for="(breadcrumb, breadcrumbIndex) in breadcrumbs">
        <router-link :to="breadcrumb.href">{{ breadcrumb.name }}</router-link>
        <svgicon class="separator" src="icon/chevron.svg" :height="10" :width="6" v-if="breadcrumbIndex < breadcrumbs.length - 1 || showingPageTitle"></svgicon>
      </template>
      <!-- Page title -->
      <template v-if="showingPageTitle">
        <span class="pageTitle">{{ pageTitle }}</span>
      </template>
    </div>

    <!--<StagingSelect ref="staging-select" v-if="contextInventory && $store.state.contextCompany" :inventory="contextInventory.id"/>-->

    <div class="servers" v-if="accessibleServers">
      <select v-model="contextServer">
        <option :value="server" v-for="server of accessibleServers">{{server.name}}</option>
      </select>
    </div>

    <div class="country" v-if="$store.state.contextCompany && $store.state.contextCompany.country">
      <svgicon :src="'/icon/country/' + $store.state.contextCompany.country + '.svg'" :width="30" :height="30"></svgicon>
    </div>

    <PayfactoSupportUrl class="btn btn-primary" />

    <a :href="$to(Parameters.urlSupport)" class="action" target="_blank">
      <img src="../assets/img/icon/info.png">
    </a>

  </div>

</template>

<script>

  import ActionMenu from "@/components/tools/ActionMenu.vue";
  import PayfactoSupportUrl from "@/components/PayfactoSupportUrl.vue";
  import StagingSelect from "@/components/inventory/StagingSelect";

  export default {

    name: "appheader",

    components: {StagingSelect, ActionMenu, PayfactoSupportUrl},

    data() {
      return {
        Parameters
      }
    },

    computed: {
      contextInventory() {
        return this.$store.state.contextInventory
      },
      accessibleServers() {
        let servers = this.$store.state.loggedUser.accessibleServers;
        if (!servers && this.$store.state.loggedUser.accessibleBranches) {
          servers = [];
          for (let branch of this.$store.state.loggedUser.accessibleBranches) {
            if (!servers.some(s => s.id === branch.server.id)) {
              servers.push(branch.server)
            }
          }
        }
        return servers;
      },
      contextServer: {
        get() {
          return this.$store.state.contextServer
        },
        set(server) {
          this.$store.commit('setContextServer', server);
          let defaultRoute = this.$store.getters.defaultRouting;
          this.$route.path === defaultRoute.path
            ? this.$router.go() /* refresh when same route */
            : this.$router.push(defaultRoute).catch(()=>{});
        }
      },
      breadcrumbs() {
        return this.$store.state.breadcrumbs;
      },
      lastBreadcrumb() {
        return this.breadcrumbs[this.breadcrumbs.length - 1];
      },
      pageTitle() {
        return this.$store.state.pageTitle;
      },
      isSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      showingPageTitle() {
        return !this.lastBreadcrumb || (this.pageTitle && this.pageTitle !== this.lastBreadcrumb.name);
      }
    },

    watch: {
      "$store.state.versionChangeCounter"() {
        this.$refs["staging-select"].reloadUpcomingVersions();
      }
    },

    methods: {
      logout() {
        this.$store.commit('logOut');
        this.$router.push("/login");
      }
    }
  };

</script>


<style lang="scss" scoped>

  #header {
    background-color: white;
    display: flex;
    padding: 0 16px;
    align-items: center;
    font-size: 16px;
  }
  .icon {
    margin-right: 20px;
    fill: #b3b3b3;
  }
  .page {
    position: relative;
  }
  .subtitle {
    flex-grow: 1;
    color: #808080;
    :last-child {
      font-weight: bold;
    }
    a, .pageTitle {
      color: #404040;
      text-decoration: none;
      display: inline-block;
    }
  }
  .action {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:last-child {
      margin-right: -10px;
    }
  }
  .separator {
    fill: #bfbfbf;
    margin: 0 10px;
    display: inline-block;
  }
  .servers {
    margin-right: 20px;
    select {
      font-size: 14px;
      padding: 4px 10px;
    }
  }
  .country {
    margin-right: 10px;
  }
</style>

<style lang="scss">
  #header .support-btn {
    text-decoration: none;
    font-size: 12px;
    padding: 8px 16px;
    font-weight: 500;
    display: flex;
    border-radius: 8px;
    margin-right: 10px;
    background-color: #b4b4b4 !important;
    text-shadow: 0 0 1px rgba(0,0,0,0.2);

    .svgicon {
      fill: white;
      margin-left: 10px;
    }
  }
</style>
